import React from 'react';

const AuthLayout: React.FC = ({ children }) => {
  return <>{children}</>;
};

export default AuthLayout;
